import {
    SET_CUSTOMER_FORM,
	RESET_CUSTOMER_FORM
} from '../constants';


export function setCustomerForm(obj) {
    return {
        type: SET_CUSTOMER_FORM,
        payload: obj
    }
}

export function resetCustomerForm() {
    return {
        type: RESET_CUSTOMER_FORM,
        payload: {}
    }
}



// WEBPACK FOOTER //
// ./src/actions/customer.js